import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { Paper, Typography, MenuItem, Checkbox, ListItemText, ListSubheader, Tab, Tabs, Container } from '@mui/material';
import { SelectMenu, Box } from '@livable/saas-react-components';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import moment from 'moment/moment';
import { TRANSACTION_TYPES, TRANSACTION_TYPESV2 } from 'src/constants/payments';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import SoloBarChart from './charts/SoloBarChart';
import { generateAddressString } from 'src/utils/address';
import { ARReportTab } from './ARReportTab';
import { ReimbursementReportTab } from './ReimbursementReportTab';
import { hex2rgba } from 'src/utils/colors';
import { currencyFormatter } from 'src/utils/translator';
import { isValueNumber } from 'src/utils/typeValidators';
import MonthRangeDatePicker from 'src/components/general/MonthRangeDatePicker';
export const ReimbursementTab = observer(() => {
  var _store$homeDashboardS, _store$homeDashboardS2;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    companyProperties = _useState4[0],
    setCompanyProperties = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    companyReport = _useState6[0],
    setCompanyReport = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    companyReportTotalUnpaid = _useState8[0],
    setCompanyReportTotalUnpaid = _useState8[1];
  const _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    soloReimbursedChartData = _useState0[0],
    setSoloReimbursedChartData = _useState0[1];
  const isDisabled = isLoading || store.report.downloadCombinedPropertiesReportAsync.inProgress || !Array.from(new Set(companyReport.map(i => i.propertyId))).length;
  const _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    propertyOptions = _useState10[0],
    setPropertyOptions = _useState10[1];
  const _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    unitOptions = _useState12[0],
    setUnitOptions = _useState12[1];
  const _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    chargeOptions = _useState14[0],
    setChargeOptions = _useState14[1];
  const _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    totalReimbursementReportData = _useState16[0],
    setTotalReimbursementReportData = _useState16[1];
  const _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    chartDataByProperty = _useState18[0],
    setChartDataByProperty = _useState18[1];
  const _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    chartDataByUnit = _useState20[0],
    setChartDataByUnit = _useState20[1];
  const _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    chartDataByPeriod = _useState22[0],
    setChartDataByPeriod = _useState22[1];
  const _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    paidPieChartData = _useState24[0],
    setPaidPieChartData = _useState24[1];
  const _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    unpaidPieChartData = _useState26[0],
    setUnpaidPieChartData = _useState26[1];
  const reportPeriodEnum = {
    lastMonth: t('reimbursement_dashboard.period_lastMonth', {
      monthName: moment(store.properties.serverBusinessDateOnly).subtract(1, 'month').startOf('month').format('MMMM')
    }),
    last90Days: t('reimbursement_dashboard.period_last90Days', {
      monthStartName: moment(store.properties.serverBusinessDateOnly).subtract(90, 'days').format('MMMM'),
      monthEndName: moment(store.properties.serverBusinessDateOnly).format('MMMM')
    }),
    currentQuarter: t('reimbursement_dashboard.period_currentQuarter', {
      monthStartName: moment(store.properties.serverBusinessDateOnly).startOf('quarter').format('MMMM'),
      monthEndName: moment(store.properties.serverBusinessDateOnly).endOf('quarter').format('MMMM')
    }),
    lastQuarter: t('reimbursement_dashboard.period_lastQuarter', {
      monthStartName: moment(store.properties.serverBusinessDateOnly).subtract(1, 'quarter').startOf('quarter').format('MMMM'),
      monthEndName: moment(store.properties.serverBusinessDateOnly).subtract(1, 'quarter').endOf('quarter').format('MMMM')
    }),
    last6Months: t('reimbursement_dashboard.period_last6Months', {
      monthStartName: moment(store.properties.serverBusinessDateOnly).subtract(6, 'months').startOf('months').format('MMMM YY'),
      monthEndName: moment(store.properties.serverBusinessDateOnly).endOf('month').format('MMMM YY')
    }),
    yearToDate: t('reimbursement_dashboard.period_yearToDate'),
    last365Days: t('reimbursement_dashboard.period_last365Days', {
      monthStartName: moment(store.properties.serverBusinessDateOnly).subtract(365, 'days').format('MMMM YYYY'),
      monthEndName: moment(store.properties.serverBusinessDateOnly).format('MMMM YYYY')
    }),
    lastYear: t('reimbursement_dashboard.period_lastYear', {
      yearName: moment(store.properties.serverBusinessDateOnly).startOf('year').subtract(1, 'year').format('YYYY')
    }),
    all: t('reimbursement_dashboard.period_whole_time'),
    //change to “All Time”
    custom: t('reimbursement_dashboard.custom_date_range')
  };
  const _useState27 = useState('lastMonth'),
    _useState28 = _slicedToArray(_useState27, 2),
    selectedPeriod = _useState28[0],
    setSelectedPeriod = _useState28[1];
  const getPropertyById = id => {
    return companyProperties[id];
  };
  const _useState29 = useState({
      startDateOnly: moment(store.properties.serverBusinessDateOnly).subtract(1, 'months').startOf('month').toDate(),
      endDateOnly: moment(store.properties.serverBusinessDateOnly).subtract(1, 'months').endOf('month').toDate()
    }),
    _useState30 = _slicedToArray(_useState29, 2),
    customDateRange = _useState30[0],
    setCustomDateRange = _useState30[1];
  const getTimePeriod = periodInMonth => {
    if (!periodInMonth || periodInMonth === 'all') {
      return {
        startDateOnly: null,
        endDateOnly: null
      };
    }
    if (periodInMonth === 'custom') {
      return {
        startDateOnly: customDateRange.startDateOnly === null ? null : moment(customDateRange.startDateOnly).format('YYYY-MM-DD'),
        endDateOnly: customDateRange.endDateOnly === null ? null : moment(customDateRange.endDateOnly).format('YYYY-MM-DD')
      };
    }
    if (periodInMonth === 'lastMonth') {
      return {
        startDateOnly: moment(store.properties.serverBusinessDateOnly).subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        endDateOnly: moment(store.properties.serverBusinessDateOnly).subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
      };
    }
    if (periodInMonth === 'last90Days') {
      return {
        startDateOnly: moment(store.properties.serverBusinessDateOnly).subtract(90, 'days').format('YYYY-MM-DD'),
        endDateOnly: moment(store.properties.serverBusinessDateOnly).format('YYYY-MM-DD')
      };
    }
    if (periodInMonth === 'currentQuarter') {
      return {
        startDateOnly: moment(store.properties.serverBusinessDateOnly).startOf('quarter').format('YYYY-MM-DD'),
        endDateOnly: moment(store.properties.serverBusinessDateOnly).endOf('quarter').format('YYYY-MM-DD')
      };
    }
    if (periodInMonth === 'lastQuarter') {
      return {
        startDateOnly: moment(store.properties.serverBusinessDateOnly).subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'),
        endDateOnly: moment(store.properties.serverBusinessDateOnly).subtract(1, 'quarter').endOf('quarter').format('YYYY-MM-DD')
      };
    }
    if (periodInMonth === 'last6Months') {
      return {
        startDateOnly: moment(store.properties.serverBusinessDateOnly).subtract(6, 'months').startOf('months').format('YYYY-MM-DD'),
        endDateOnly: moment(store.properties.serverBusinessDateOnly).endOf('month').format('YYYY-MM-DD')
      };
    }
    if (periodInMonth === 'yearToDate') {
      return {
        startDateOnly: moment(store.properties.serverBusinessDateOnly).startOf('year').format('YYYY-MM-DD'),
        endDateOnly: moment(store.properties.serverBusinessDateOnly).format('YYYY-MM-DD')
      };
    }
    if (periodInMonth === 'last365Days') {
      return {
        startDateOnly: moment(store.properties.serverBusinessDateOnly).subtract(365, 'days').format('YYYY-MM-DD'),
        endDateOnly: moment(store.properties.serverBusinessDateOnly).format('YYYY-MM-DD')
      };
    }
    if (periodInMonth === 'lastYear') {
      return {
        startDateOnly: moment(store.properties.serverBusinessDateOnly).startOf('year').subtract(1, 'year').format('YYYY-MM-DD'),
        endDateOnly: moment(store.properties.serverBusinessDateOnly).subtract(1, 'year').endOf('year').format('YYYY-MM-DD')
      };
    }
    const endDateOnly = moment(store.properties.serverBusinessDateOnly).endOf('month');
    const startDateOnly = moment(endDateOnly).subtract('months', periodInMonth).startOf('month');
    return {
      startDateOnly: startDateOnly.format('YYYY-MM-DD'),
      endDateOnly: endDateOnly.format('YYYY-MM-DD')
    };
  };
  const _useState31 = useState('ar-report'),
    _useState32 = _slicedToArray(_useState31, 2),
    selectedTab = _useState32[0],
    setSelectedTab = _useState32[1];
  const handleTabChange = (e, value) => setSelectedTab(value);
  const getTab = () => {
    switch (selectedTab) {
      case 'reimbursement':
        return /*#__PURE__*/React.createElement(ReimbursementReportTab, {
          totalReimbursementReportData: totalReimbursementReportData,
          chartDataByProperty: chartDataByProperty,
          chartDataByUnit: chartDataByUnit,
          chartDataByPeriod: chartDataByPeriod,
          period: getTimePeriod(selectedPeriod),
          periodName: reportPeriodEnum[selectedPeriod],
          unpaidPieChartData: unpaidPieChartData,
          paidPieChartData: paidPieChartData,
          isLoading: isLoading
        });
      case 'ar-report':
      default:
        return /*#__PURE__*/React.createElement(ARReportTab, {
          companyReport: companyReport,
          companyReportTotalUnpaid: companyReportTotalUnpaid,
          isLoading: isLoading,
          isDisabled: isDisabled,
          propertyOptions: propertyOptions,
          getPropertyById: getPropertyById
        });
    }
  };
  const getCompanyPropertyList = async () => {
    const resp = await store.company.getCompanyPropertyListAsync.run();
    if (resp && resp.isSuccessful) {
      setCompanyProperties(resp.response.reduce((previousValue, currentValue) => {
        return Object.assign({}, previousValue, {
          [currentValue.propertyId]: currentValue
        });
      }, {}));
    }
    return resp;
  };
  const getCompanyTeamMembers = async () => {
    const resp = await store.teamMembers.getCompanyTeamMembersAsync.run({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    });
    return resp;
  };
  const reimbursementFilterOptionsEnum = {
    propertyOptions: 'propertyOptions',
    unitOptions: 'unitOptions',
    periodOptions: 'periodOptions',
    chargeOptions: 'chargeOptions'
  };
  const getReimbursementFiltersV2 = async () => {
    const reimbursementFiltersResp = await store.report.getReimbursementAsync.run({});
    if (reimbursementFiltersResp && reimbursementFiltersResp !== null && reimbursementFiltersResp !== void 0 && reimbursementFiltersResp.isSuccessful) {
      const response = reimbursementFiltersResp.response;
      const finalRes = Object.entries(reimbursementFilterOptionsEnum).reduce((previousValue, currentValue) => {
        const result = _objectSpread({}, previousValue);
        const _currentValue = _slicedToArray(currentValue, 1),
          key = _currentValue[0];
        switch (key) {
          case reimbursementFilterOptionsEnum.propertyOptions:
            {
              setPropertyOptions(response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              }));
              result[key] = response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              });
              break;
            }
          case reimbursementFilterOptionsEnum.unitOptions:
            {
              setUnitOptions(response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              }));
              result[key] = response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              });
              break;
            }
          case reimbursementFilterOptionsEnum.chargeOptions:
            {
              setChargeOptions(response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              }));
              result[key] = response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              });
              break;
            }
        }
        return result;
      }, {});
      return Object.assign(finalRes, {
        isSuccessful: reimbursementFiltersResp === null || reimbursementFiltersResp === void 0 ? void 0 : reimbursementFiltersResp.isSuccessful
      });
    }
  };
  const getPropertyReport = async _ref => {
    let propertyIds = _ref.propertyIds;
    const resp = await store.report.getPropertiesReportsAsync.run(propertyIds);
    if (resp && resp.isSuccessful) {
      var _resp$response, _resp$response2;
      setCompanyReport((_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.data.map(i => i));
      setCompanyReportTotalUnpaid((_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.totalUnpaid);
    }
    return resp;
  };
  const getChartsData = async function () {
    let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$propertyOptions = _ref2.propertyOptionsExt,
      propertyOptionsExt = _ref2$propertyOptions === void 0 ? undefined : _ref2$propertyOptions,
      _ref2$unitOptionsExt = _ref2.unitOptionsExt,
      unitOptionsExt = _ref2$unitOptionsExt === void 0 ? undefined : _ref2$unitOptionsExt,
      _ref2$chargeOptionsEx = _ref2.chargeOptionsExt,
      chargeOptionsExt = _ref2$chargeOptionsEx === void 0 ? undefined : _ref2$chargeOptionsEx,
      _ref2$selectedPeriodE = _ref2.selectedPeriodExt,
      selectedPeriodExt = _ref2$selectedPeriodE === void 0 ? undefined : _ref2$selectedPeriodE,
      _ref2$customPeriodExt = _ref2.customPeriodExt,
      customPeriodExt = _ref2$customPeriodExt === void 0 ? undefined : _ref2$customPeriodExt;
    setIsLoading(true);
    const propertyOptionsQuery = propertyOptionsExt !== null && propertyOptionsExt !== void 0 ? propertyOptionsExt : propertyOptions;
    const unitOptionsQuery = unitOptionsExt !== null && unitOptionsExt !== void 0 ? unitOptionsExt : unitOptions;
    const chargeOptionsQuery = chargeOptionsExt !== null && chargeOptionsExt !== void 0 ? chargeOptionsExt : chargeOptions;
    const selectedPeriodQuery = selectedPeriodExt !== null && selectedPeriodExt !== void 0 ? selectedPeriodExt : selectedPeriod;
    const query = {};
    if (propertyOptionsQuery.length && propertyOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).length) {
      query.propertyIds = propertyOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).map(property => property === null || property === void 0 ? void 0 : property.propertyId);
    }
    if (unitOptionsQuery.length && unitOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).length) {
      query.unitIds = unitOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).map(unit => unit === null || unit === void 0 ? void 0 : unit.unitId);
    }
    if (customPeriodExt === undefined) {
      Object.assign(query, getTimePeriod(selectedPeriodQuery));
    } else {
      Object.assign(query, customPeriodExt);
    }
    if (chargeOptionsQuery.length && chargeOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).length) {
      query.selectedChargeTypes = chargeOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).map(chargeType => {
        return {
          utilityTypeId: chargeType === null || chargeType === void 0 ? void 0 : chargeType.utilityTypeId,
          chargeType: chargeType === null || chargeType === void 0 ? void 0 : chargeType.chargeType
        };
      });
    }
    const reimbursementGraphsV2Resp = await store.report.getReimbursementReportV2Async.run(_objectSpread({}, query));
    const reimbursementReportSlimResp = await store.report.getReimbursementReportSlimAsync.run(_objectSpread({}, query));
    setSoloReimbursedChartData(null);
    if (reimbursementReportSlimResp !== null && reimbursementReportSlimResp !== void 0 && reimbursementReportSlimResp.isSuccessful && !!(reimbursementReportSlimResp !== null && reimbursementReportSlimResp !== void 0 && reimbursementReportSlimResp.response)) {
      await setSoloReimbursedChartData(reimbursementReportSlimResp === null || reimbursementReportSlimResp === void 0 ? void 0 : reimbursementReportSlimResp.response);
    }
    if (reimbursementGraphsV2Resp !== null && reimbursementGraphsV2Resp !== void 0 && reimbursementGraphsV2Resp.isSuccessful && !!(reimbursementGraphsV2Resp !== null && reimbursementGraphsV2Resp !== void 0 && reimbursementGraphsV2Resp.response)) {
      const _reimbursementGraphsV = reimbursementGraphsV2Resp === null || reimbursementGraphsV2Resp === void 0 ? void 0 : reimbursementGraphsV2Resp.response,
        totalCharged = _reimbursementGraphsV.totalCharged,
        totalPaid = _reimbursementGraphsV.totalPaid,
        totalUnpaid = _reimbursementGraphsV.totalUnpaid,
        totalCredited = _reimbursementGraphsV.totalCredited,
        totalPaidPercentage = _reimbursementGraphsV.totalPaidPercentage,
        totalUnpaidPercentage = _reimbursementGraphsV.totalUnpaidPercentage,
        totalCreditedPercentage = _reimbursementGraphsV.totalCreditedPercentage,
        lifetimePaid = _reimbursementGraphsV.lifetimePaid,
        recoveryEffectiveness = _reimbursementGraphsV.recoveryEffectiveness,
        reimbursementEffectiveness = _reimbursementGraphsV.reimbursementEffectiveness,
        dataByProperty = _reimbursementGraphsV.dataByProperty,
        dataByUnit = _reimbursementGraphsV.dataByUnit,
        dataByPeriod = _reimbursementGraphsV.dataByPeriod;
      dataByProperty.data.forEach((item, index) => {
        var _propertyOptionsQuery, _propertyOptionsQuery2;
        dataByProperty.data[index].propertyName = (_propertyOptionsQuery = (_propertyOptionsQuery2 = propertyOptionsQuery.find(propertyOption => propertyOption.propertyId === item.propertyId)) === null || _propertyOptionsQuery2 === void 0 ? void 0 : _propertyOptionsQuery2.propertyName) !== null && _propertyOptionsQuery !== void 0 ? _propertyOptionsQuery : 'N/a';
        dataByProperty.data[index].label = dataByProperty.data[index].propertyName;
      });
      dataByUnit.data.forEach((item, index) => {
        var _propertyOptionsQuery3, _propertyOptionsQuery4, _unitOptionsQuery$fin, _unitOptionsQuery$fin2;
        dataByUnit.data[index].propertyName = (_propertyOptionsQuery3 = (_propertyOptionsQuery4 = propertyOptionsQuery.find(propertyOption => propertyOption.propertyId === item.propertyId)) === null || _propertyOptionsQuery4 === void 0 ? void 0 : _propertyOptionsQuery4.propertyName) !== null && _propertyOptionsQuery3 !== void 0 ? _propertyOptionsQuery3 : 'N/a';
        dataByUnit.data[index].unitName = (_unitOptionsQuery$fin = (_unitOptionsQuery$fin2 = unitOptionsQuery.find(unitOption => unitOption.propertyId === item.propertyId && unitOption.unitId === item.unitId)) === null || _unitOptionsQuery$fin2 === void 0 ? void 0 : _unitOptionsQuery$fin2.unitName) !== null && _unitOptionsQuery$fin !== void 0 ? _unitOptionsQuery$fin : 'N/a';
        dataByUnit.data[index].label = dataByUnit.data[index].unitName;
      });
      dataByPeriod.data.forEach((item, index) => {
        dataByPeriod.data[index].label = moment(item.startDateOnly).format('MMM YYYY');
      });
      setTotalReimbursementReportData({
        totalCharged,
        totalPaid,
        totalUnpaid,
        totalCredited,
        totalPaidPercentage,
        totalUnpaidPercentage,
        totalCreditedPercentage,
        lifetimePaid,
        recoveryEffectiveness,
        reimbursementEffectiveness
      });
      setChartDataByProperty(dataByProperty.data.sort((a, b) => a.propertyName.localeCompare(b.propertyName)));
      setChartDataByUnit(dataByUnit.data.sort((a, b) => {
        var _ref3;
        return a.propertyName === b.propertyName ? (_ref3 = '' + (a === null || a === void 0 ? void 0 : a.unitName)) === null || _ref3 === void 0 ? void 0 : _ref3.localeCompare(b === null || b === void 0 ? void 0 : b.unitName, undefined, {
          numeric: true
        }) : a.propertyName.localeCompare(b.propertyName);
      }));
      setChartDataByPeriod(dataByPeriod.data.sort((a, b) => {
        return moment.utc(a.startDateOnly).diff(moment.utc(b.startDateOnly));
      }));
      const dataByType = reimbursementGraphsV2Resp.response.dataByType.data;
      setPaidPieChartData(dataByType.filter(i => i.paid !== 0).map(i => {
        return _objectSpread({
          name: i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeName : i.chargeType,
          value: i.paid
        }, i);
      }));
      setUnpaidPieChartData(dataByType.filter(i => i.unpaid !== 0).map(i => {
        return _objectSpread({
          name: i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeName : i.chargeType,
          value: i.unpaid
        }, i);
      }));
    } else {
      setTotalReimbursementReportData(null);
      setChartDataByProperty(null);
      setChartDataByUnit(null);
      setChartDataByPeriod(null);
      setPaidPieChartData(null);
      setUnpaidPieChartData(null);
    }
    setIsLoading(false);
  };
  const handleDateChange = function (fromDate, toDate) {
    let isPeriodCustom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const result = {
      startDateOnly: fromDate === null ? null : moment(fromDate).toDate(),
      endDateOnly: toDate === null ? null : moment(toDate).toDate()
    };
    setCustomDateRange(result);
    if (fromDate && toDate) {
      if (isPeriodCustom) setSelectedPeriod('custom');
      const customPeriodExt = {
        startDateOnly: fromDate === null ? null : moment(fromDate).format('YYYY-MM-DD'),
        endDateOnly: toDate === null ? null : moment(toDate).format('YYYY-MM-DD')
      };
      getChartsData({
        customPeriodExt
      });
    }
  };
  const updateFilterSelectionValueV2 = async _ref4 => {
    let filterName = _ref4.filterName,
      valueId = _ref4.valueId;
    const isFilterSelectAll = valueId === 'select-all';
    const fetchQuery = {
      propertyOptionsExt: propertyOptions,
      unitOptionsExt: unitOptions,
      chargeOptionsExt: chargeOptions,
      selectedPeriodExt: selectedPeriod
    };
    switch (filterName) {
      case reimbursementFilterOptionsEnum.propertyOptions:
        {
          var _fetchQuery$propertyO2;
          const resultUnits = [...unitOptions];
          if (isFilterSelectAll) {
            var _propertyOptions$filt, _fetchQuery$propertyO;
            const isUnSelectedExists = !!(propertyOptions !== null && propertyOptions !== void 0 && (_propertyOptions$filt = propertyOptions.filter(i => !i.isChosen)) !== null && _propertyOptions$filt !== void 0 && _propertyOptions$filt.length);
            setPropertyOptions(propertyOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            }));
            fetchQuery.propertyOptionsExt = propertyOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            });
            resultUnits.forEach((unit, index) => {
              resultUnits[index].isChosen = isUnSelectedExists;
            });
            setUnitOptions(resultUnits);
            getPropertyReport({
              propertyIds: (_fetchQuery$propertyO = fetchQuery.propertyOptionsExt) === null || _fetchQuery$propertyO === void 0 ? void 0 : _fetchQuery$propertyO.filter(i => i.isChosen).map(i => i.propertyId)
            });
            break;
          }
          const result = [...propertyOptions];
          const toUpdateIndex = propertyOptions.findIndex(i => i.propertyId === valueId);
          result[toUpdateIndex].isChosen = !result[toUpdateIndex].isChosen;
          fetchQuery.propertyOptionsExt = result;
          resultUnits.forEach((unit, index) => {
            if (unit.propertyId === valueId) {
              resultUnits[index].isChosen = result[toUpdateIndex].isChosen;
            }
          });
          setPropertyOptions(result);
          setUnitOptions(resultUnits);
          fetchQuery.unitOptionsExt = resultUnits;
          getPropertyReport({
            propertyIds: (_fetchQuery$propertyO2 = fetchQuery.propertyOptionsExt) === null || _fetchQuery$propertyO2 === void 0 ? void 0 : _fetchQuery$propertyO2.filter(i => i.isChosen).map(i => i.propertyId)
          });
          break;
        }
      case reimbursementFilterOptionsEnum.unitOptions:
        {
          if (isFilterSelectAll) {
            var _unitOptions$filter;
            const isUnSelectedExists = !!(unitOptions !== null && unitOptions !== void 0 && (_unitOptions$filter = unitOptions.filter(i => !i.isChosen)) !== null && _unitOptions$filter !== void 0 && _unitOptions$filter.length);
            setUnitOptions(unitOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            }));
            fetchQuery.unitOptionsExt = unitOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            });
            break;
          }
          const result = [...unitOptions];
          const toUpdateIndex = unitOptions.findIndex(i => i.unitId === valueId);
          result[toUpdateIndex].isChosen = !result[toUpdateIndex].isChosen;
          setUnitOptions(result);
          fetchQuery.unitOptionsExt = result;
          break;
        }
      case reimbursementFilterOptionsEnum.periodOptions:
        {
          setSelectedPeriod(valueId);
          fetchQuery.selectedPeriodExt = valueId;
          const period = getTimePeriod(valueId);
          handleDateChange(period.startDateOnly, period.endDateOnly);
          break;
        }
      case reimbursementFilterOptionsEnum.chargeOptions:
        {
          if (isFilterSelectAll) {
            var _chargeOptions$filter;
            const isUnSelectedExists = !!(chargeOptions !== null && chargeOptions !== void 0 && (_chargeOptions$filter = chargeOptions.filter(i => !i.isChosen)) !== null && _chargeOptions$filter !== void 0 && _chargeOptions$filter.length);
            setChargeOptions(chargeOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            }));
            fetchQuery.chargeOptionsExt = chargeOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            });
            break;
          }
          const result = [...chargeOptions];
          const toUpdateIndex = chargeOptions.findIndex(i => i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeId === valueId : i.chargeType === valueId);
          result[toUpdateIndex].isChosen = !result[toUpdateIndex].isChosen;
          setChargeOptions(result);
          fetchQuery.chargeOptionsExt = result;
          break;
        }
    }
    await getChartsData(fetchQuery);
  };
  const getFilterSelectedV2 = _ref5 => {
    let filterName = _ref5.filterName,
      labelKey = _ref5.labelKey,
      _ref5$labelKey = _ref5.labelKey2,
      labelKey2 = _ref5$labelKey === void 0 ? undefined : _ref5$labelKey;
    switch (filterName) {
      case reimbursementFilterOptionsEnum.propertyOptions:
        {
          const chosenItems = propertyOptions.filter(i => i.isChosen) || [];
          if ((chosenItems === null || chosenItems === void 0 ? void 0 : chosenItems.length) === 0) return [];
          const resultOptions = chosenItems.map(i => i[labelKey]);
          return (resultOptions === null || resultOptions === void 0 ? void 0 : resultOptions.length) === 0 ? [] : resultOptions;
        }
      case reimbursementFilterOptionsEnum.unitOptions:
        {
          const chosenItems = unitOptions.filter(i => i.isChosen) || [];
          if ((chosenItems === null || chosenItems === void 0 ? void 0 : chosenItems.length) === 0) return [];
          const resultOptions = chosenItems.map(i => i[labelKey]);
          return (resultOptions === null || resultOptions === void 0 ? void 0 : resultOptions.length) === 0 ? [] : resultOptions;
        }
      case reimbursementFilterOptionsEnum.periodOptions:
        {
          return reportPeriodEnum[selectedPeriod];
        }
      case reimbursementFilterOptionsEnum.chargeOptions:
        {
          const chosenItems = chargeOptions.filter(i => i.isChosen) || [];
          if ((chosenItems === null || chosenItems === void 0 ? void 0 : chosenItems.length) === 0) return [];
          const resultOptions = chosenItems.map(i => i[i.chargeType === TRANSACTION_TYPESV2.UtilityCharge && !!labelKey2 ? labelKey2 : labelKey]);
          return (resultOptions === null || resultOptions === void 0 ? void 0 : resultOptions.length) === 0 ? [] : resultOptions;
        }
    }
  };
  const getIsSelectedAllV2 = _ref6 => {
    let filterName = _ref6.filterName;
    switch (filterName) {
      case reimbursementFilterOptionsEnum.propertyOptions:
        {
          return propertyOptions.filter(i => !(i !== null && i !== void 0 && i.isChosen)).length;
        }
      case reimbursementFilterOptionsEnum.unitOptions:
        {
          return unitOptions.filter(i => !(i !== null && i !== void 0 && i.isChosen)).length;
        }
      case reimbursementFilterOptionsEnum.periodOptions:
        {
          break;
        }
      case reimbursementFilterOptionsEnum.chargeOptions:
        {
          return chargeOptions.filter(i => !(i !== null && i !== void 0 && i.isChosen)).length;
        }
    }
  };
  useEffect(() => {
    setIsLoading(true);
    Promise.all([getCompanyPropertyList(), getCompanyTeamMembers()]).then(async responses => {
      var _responses$;
      await Promise.all([getReimbursementFiltersV2().then(async filtersResp => {
        if (filtersResp && filtersResp.isSuccessful) {
          await getChartsData({
            propertyOptionsExt: filtersResp[reimbursementFilterOptionsEnum.propertyOptions],
            unitOptionsExt: filtersResp[reimbursementFilterOptionsEnum.unitOptions],
            periodOptionsExt: filtersResp[reimbursementFilterOptionsEnum.periodOptions],
            chargeOptionsExt: filtersResp[reimbursementFilterOptionsEnum.chargeOptions]
          });
        }
      }), getPropertyReport({
        propertyIds: (_responses$ = responses[0]) === null || _responses$ === void 0 || (_responses$ = _responses$.response) === null || _responses$ === void 0 ? void 0 : _responses$.map(i => i.propertyId)
      })]);
    }).finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, (store.company.companyFeatureStore.enableReimbursementReport || ((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.companyFeatureSet) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.enableReimbursementReport)) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('reimbursement_dashboard.reimbursement_dashboard')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('reimbursement_dashboard.reimbursement_dashboard_desc')), /*#__PURE__*/React.createElement("div", {
    className: classes.selectors
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mdSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "property-selector",
    value: getFilterSelectedV2({
      filterName: reimbursementFilterOptionsEnum.propertyOptions,
      filterSelectedKey: 'propertyId',
      labelKey: 'propertyName'
    }) || 'all-properties',
    label: t('reimbursement_dashboard.property'),
    labelId: "property-selector-label",
    multiple: true,
    disabled: isLoading,
    onChange: event => updateFilterSelectionValueV2({
      filterName: reimbursementFilterOptionsEnum.propertyOptions,
      valueId: event.target.value[event.target.value.length - 1]
    }),
    renderValue: selected => {
      return !getIsSelectedAllV2({
        filterName: reimbursementFilterOptionsEnum.propertyOptions
      }) ? t('reimbursement_dashboard.all_properties') : selected.join(', ');
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: "select-all",
    value: 'select-all',
    variant: "multiple"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !getIsSelectedAllV2({
      filterName: reimbursementFilterOptionsEnum.propertyOptions
    })
  }), /*#__PURE__*/React.createElement(ListItemText, null, t('reimbursement_dashboard.all_properties'))), propertyOptions.length && propertyOptions.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    key: i.propertyId,
    value: i.propertyId,
    variant: "multiple"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: i.isChosen
  }), /*#__PURE__*/React.createElement(ListItemText, null, i === null || i === void 0 ? void 0 : i.propertyName))))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "unit-selector",
    key: "unit-selector",
    value: getFilterSelectedV2({
      filterName: reimbursementFilterOptionsEnum.unitOptions,
      labelKey: 'unitName'
    }),
    label: t('reimbursement_dashboard.unit'),
    labelId: "unit-selector-label",
    multiple: true,
    disabled: isLoading,
    onChange: event => {
      updateFilterSelectionValueV2({
        filterName: reimbursementFilterOptionsEnum.unitOptions,
        valueId: event.target.value[event.target.value.length - 1]
      });
    },
    renderValue: () => {
      return !getIsSelectedAllV2({
        filterName: reimbursementFilterOptionsEnum.unitOptions
      }) ? t('reimbursement_dashboard.all_units') : getFilterSelectedV2({
        filterName: reimbursementFilterOptionsEnum.unitOptions,
        labelKey: 'unitName'
      }).join(', ');
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: "select-all",
    value: 'select-all',
    variant: "multiple"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !getIsSelectedAllV2({
      filterName: reimbursementFilterOptionsEnum.unitOptions
    })
  }), /*#__PURE__*/React.createElement(ListItemText, null, t('reimbursement_dashboard.all_units'))), !!unitOptions.length && unitOptions.sort((a, b) => {
    var _ref7;
    return (_ref7 = '' + (a === null || a === void 0 ? void 0 : a.propertyId)) === null || _ref7 === void 0 ? void 0 : _ref7.localeCompare(b === null || b === void 0 ? void 0 : b.propertyId, undefined, {
      numeric: true
    });
  }).sort((a, b) => {
    if ((a === null || a === void 0 ? void 0 : a.propertyId) === b.propertyId) {
      var _ref8;
      return (_ref8 = '' + (a === null || a === void 0 ? void 0 : a.unitName)) === null || _ref8 === void 0 ? void 0 : _ref8.localeCompare(b === null || b === void 0 ? void 0 : b.unitName, undefined, {
        numeric: true
      });
    }
    return 0;
  }).filter(unitOption => propertyOptions.find(property => property.propertyId === unitOption.propertyId).isChosen).map((i, index, array) => {
    var _array;
    if (index === 0 || ((_array = array[index - 1]) === null || _array === void 0 ? void 0 : _array.propertyId) !== i.propertyId) {
      var _getPropertyById;
      return [/*#__PURE__*/React.createElement(ListSubheader, {
        key: 'unit-selector-property' + i.propertyId
      }, generateAddressString((_getPropertyById = getPropertyById(i.propertyId)) === null || _getPropertyById === void 0 ? void 0 : _getPropertyById.address)), /*#__PURE__*/React.createElement(MenuItem, {
        key: i.unitId,
        value: i.unitId,
        variant: "multiple"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        checked: i.isChosen,
        disabled: i.disabled
      }), /*#__PURE__*/React.createElement(ListItemText, null, i.unitName))];
    }
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: i.unitId,
      value: i.unitId,
      variant: "multiple"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: i.isChosen,
      disabled: i.disabled
    }), /*#__PURE__*/React.createElement(ListItemText, null, i.unitName));
  }).flat())), /*#__PURE__*/React.createElement("div", {
    className: classes.smSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "billing-periods-selector",
    value: getFilterSelectedV2({
      filterName: reimbursementFilterOptionsEnum.periodOptions
    }),
    label: t('reimbursement_dashboard.period'),
    labelId: "billing-periods-selector",
    renderValue: () => {
      return getFilterSelectedV2({
        filterName: reimbursementFilterOptionsEnum.periodOptions
      }) || t('reimbursement_dashboard.period_whole_time');
    },
    disabled: isLoading,
    onChange: event => {
      updateFilterSelectionValueV2({
        filterName: reimbursementFilterOptionsEnum.periodOptions,
        valueId: event.target.value
      });
    }
  }, Object.entries(reportPeriodEnum).map(_ref9 => {
    let _ref0 = _slicedToArray(_ref9, 2),
      key = _ref0[0],
      value = _ref0[1];
    return /*#__PURE__*/React.createElement(MenuItem, {
      value: key
    }, value);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSelector, " ").concat(classes.customPeriodSelector)
  }, /*#__PURE__*/React.createElement(MonthRangeDatePicker, {
    label: selectedPeriod === 'all' ? t('reimbursement_dashboard.period_whole_time') : undefined,
    fromDateExternal: customDateRange.startDateOnly,
    toDateExternal: customDateRange.endDateOnly,
    handleDateChange: (fromDate, toDate) => handleDateChange(fromDate, toDate, true),
    format: 'MM/yyyy',
    disabled: isLoading
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.smSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "charges-selector",
    value: getFilterSelectedV2({
      filterName: reimbursementFilterOptionsEnum.chargeOptions,
      labelKey: 'chargeType',
      labelKey2: 'utilityTypeName'
    }),
    label: t('reimbursement_dashboard.charges'),
    labelId: "charges-selector-label",
    multiple: true,
    disabled: isLoading,
    renderValue: () => {
      return !getIsSelectedAllV2({
        filterName: reimbursementFilterOptionsEnum.chargeOptions
      }) ? t('reimbursement_dashboard.all_charges') : getFilterSelectedV2({
        filterName: reimbursementFilterOptionsEnum.chargeOptions,
        labelKey: 'chargeType',
        labelKey2: 'utilityTypeName'
      }).join(', ');
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: "select-all",
    value: 'select-all',
    variant: "multiple",
    onClick: () => {
      updateFilterSelectionValueV2({
        filterName: reimbursementFilterOptionsEnum.chargeOptions,
        valueId: 'select-all'
      });
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !getIsSelectedAllV2({
      filterName: reimbursementFilterOptionsEnum.chargeOptions
    })
  }), /*#__PURE__*/React.createElement(ListItemText, null, t('reimbursement_dashboard.all_charges'))), !!chargeOptions.length && chargeOptions.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    key: i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeId : i.chargeType,
    value: i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeId : i.chargeType,
    variant: "multiple",
    onClick: () => {
      updateFilterSelectionValueV2({
        filterName: reimbursementFilterOptionsEnum.chargeOptions,
        valueId: i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeId : i.chargeType
      });
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: i.isChosen
  }), /*#__PURE__*/React.createElement(ListItemText, null, i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i === null || i === void 0 ? void 0 : i.utilityTypeName : TRANSACTION_TYPES[i.chargeType]))))))), !store.report.getReimbursementReportSlimAsync.inProgress && soloReimbursedChartData !== null && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.soloChartHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.soloChartHeaderItem
  }, t('reimbursement_dashboard.reimbursed'), ': ', /*#__PURE__*/React.createElement("span", {
    style: {
      color: hex2rgba('#259D58', 0.5)
    }
  }, isValueNumber(soloReimbursedChartData === null || soloReimbursedChartData === void 0 ? void 0 : soloReimbursedChartData.totalPaid) ? currencyFormatter(soloReimbursedChartData.totalPaid) : 'N/A')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.soloChartHeaderItem
  }, t('reimbursement_dashboard.credited'), ': ', /*#__PURE__*/React.createElement("span", {
    style: {
      color: hex2rgba('#2A85D1', 0.5)
    }
  }, isValueNumber(soloReimbursedChartData === null || soloReimbursedChartData === void 0 ? void 0 : soloReimbursedChartData.totalCredited) ? currencyFormatter(soloReimbursedChartData.totalCredited) : 'N/A')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.soloChartHeaderItem
  }, t('reimbursement_dashboard.unpaid'), ': ', /*#__PURE__*/React.createElement("span", {
    style: {
      color: hex2rgba('#C43131', 0.5)
    }
  }, isValueNumber(soloReimbursedChartData.totalUnpaid) ? currencyFormatter(soloReimbursedChartData.totalUnpaid) : 'N/A'))), /*#__PURE__*/React.createElement("div", {
    className: classes.soloChartContent
  }, /*#__PURE__*/React.createElement(SoloBarChart, {
    data: [soloReimbursedChartData]
  })))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xlSection, " ").concat(classes.test)
  }, (store.company.companyFeatureStore.enableReimbursementReport || ((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.companyFeatureSet) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.enableReimbursementReport)) && /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "reports tabs navigation",
    onChange: handleTabChange,
    position: "sticky",
    value: selectedTab
  }, /*#__PURE__*/React.createElement(Tab, {
    label: t('reimbursement_dashboard.ar_report_tab_name'),
    value: 'ar-report',
    'custom-attribute': '781-reporting-page-ar'
  }), /*#__PURE__*/React.createElement(Tab, {
    label: t('reimbursement_dashboard.reimbursement_tab_name'),
    value: "reimbursement",
    'custom-attribute': '782-reporting-page-reimbursement'
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, getTab()))))));
});